<template>
	<div id="elements">
		<router-link :to="{name: 'PageElements'}">PageElements</router-link>
		<router-link :to="{name: 'PagePlace'}">PagePlace</router-link>
		<router-link :to="{name: 'PageTime'}">PageTime</router-link>

		<div class="container">

			<div class="row">
				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-primary btn-wp">Stadt wählen</button>
				</div>

				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-primary btn-block btn-wp">Stadt wählen</button>
				</div>
				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-primary">Stadt wählen</button>
				</div>
			</div>

			<div class="row">
				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-secondary btn-wp">Auswählen</button>
				</div>
				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-secondary btn-block btn-wp">Auswählen</button>
				</div>
				<div class="col col-12 col-md-4">
					<button type="button" class="btn btn-secondary">Auswählen</button>
				</div>
			</div>

			<div class="row">
				<div class="col col-12">
					<button type="button" class="btn btn-outline-info btn-wp">Details</button>
				</div>
			</div>

			<div class="row">
				<div class="col col-12">
					<h1>{{ $t('Select the location') }}</h1>
				</div>
			</div>

			<div class="row">
				<div class="col col-12">
					<div class="btn-group">
						<Dropdown :buttonclass="'btn-primary'" :items="['Bitte wählen', 'Pascal', 'Stefan', 'Sven']"></Dropdown>&nbsp;
						<Dropdown :buttonclass="'btn-secondary'" :items="['Bitte wählen', 'Pascal', 'Stefan', 'Sven']"></Dropdown>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col col-12 bg-dark">
					<div class="btn-group">
						<Dropdown :buttonclass="'btn-light'" :items="['Bitte wählen', 'Pascal', 'Stefan', 'Sven']"></Dropdown>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col col-12 bg-picture-darken">
					<h1>{{ $t('Select the location') }}</h1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageElements'
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/PageElements.vue